import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

const AddButtonSmall = ({ title, onClick }) => {
  return (
    <Button onClick={onClick}>
      <Box
        component={Icon}
        icon={"eva:plus-outline"}
        style={{ margin: "0 8px" }}
      />
      <span>{title}</span>
    </Button>
  );
};

const Button = styled.button`
  font-family: Din;
  border-radius: 6px;
  background-color: ${COLORS.primary};
  border: 1.5px solid #e7e7e9;
  height: 38px;
  white-space: nowrap;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-Items:center;
  padding: 5px 11px;
  margin-left: 10px;
  font-size: 0.82rem;
  &:focus {
    outline-color: ${COLORS.primary};
  }
`;

const Title = styled.span`
  margin-right: 10px;
`;

export default AddButtonSmall;
